import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import TopNav from "../components/TopNav";
import BackButton from "../components/BackButton";
import "./DocumentsPage.css";

const DocumentsPage = (props) => {
    const [searchParams] = useSearchParams();
    
    // List of available documents in public/documents folder
    const documents = [
        {
            id: 'fom',
            name: 'Flight Operations Manual',
            filename: 'fdxva_fom.html',
            type: 'html',
            icon: '📖',
            description: 'Complete Flight Operations Manual'
        },
        {
            id: 'awo-handbook',
            name: 'AWO Handbook',
            filename: 'awo_handbook.html',
            type: 'html',
            icon: '✈️',
            description: 'All Weather Operations Handbook'
        },

        // {
        //     id: 'hub-sop',
        //     name: 'Hub Manual - SOP',
        //     filename: 'fdxva_hubman_sop.pdf',
        //     type: 'pdf',
        //     icon: '📄',
        //     description: 'Hub Operations Standard Operating Procedures'
        // },
        {
            id: 'ramp',
            name: 'Memphis Ramp',
            filename: 'fdxramp.pdf',
            type: 'pdf',
            icon: '📋',
            description: 'Memphis Red Zone Ramp Map (pdf)'
        },
        {
            id: 'china-rvsm',
            name: 'China RVSM Chart',
            filename: 'ChinaRVSM.jpg',
            type: 'image',
            icon: '🗺️',
            description: 'China RVSM Airspace Chart (jpg)'
        },
        // {
        //     id: 'sample-flight',
        //     name: 'Sample Flight Report',
        //     filename: 'FDX410_KDFW-KMEM_13-Feb-2021_1.txt',
        //     type: 'text',
        //     icon: '📝',
        //     description: 'Example Flight Report - FDX410'
        // }
    ];

    // State to track which document is selected
    const [selectedDoc, setSelectedDoc] = useState(documents[0]);
    
    // Effect to handle URL parameter for document selection
    useEffect(() => {
        const docParam = searchParams.get('doc');
        if (docParam) {
            const foundDoc = documents.find(doc => doc.id === docParam);
            if (foundDoc) {
                setSelectedDoc(foundDoc);
            }
        }
    }, [searchParams]);
    
    // State to track modal visibility for full-size image
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Function to get the file path
    const getDocumentPath = (filename) => {
        console.log(`${process.env.PUBLIC_URL}/documents/${filename}`)
        return `${process.env.PUBLIC_URL}/documents/${filename}`;
    };

    // Function to render document content based on type
    const renderDocument = (doc) => {
        const path = getDocumentPath(doc.filename);
        
        switch(doc.type) {
            case 'html':
                return (
                    <iframe
                        src={path}
                        title={doc.name}
                        className="doc-iframe"
                        sandbox="allow-same-origin allow-scripts"
                    />
                );
            case 'pdf':
                return (
                    <iframe
                        src={path}
                        title={doc.name}
                        className="doc-iframe"
                        type="application/pdf"
                    />
                );
            case 'image':
                return (
                    <div className="doc-image-container">
                        <img
                            src={path}
                            alt={doc.name}
                            className="doc-image"
                            onClick={() => setIsModalOpen(true)}
                            role="button"
                            tabIndex={0}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    setIsModalOpen(true);
                                }
                            }}
                            style={{ cursor: 'pointer' }}
                            title="Click to view full size"
                        />
                    </div>
                );
            case 'text':
                return (
                    <iframe
                        src={path}
                        title={doc.name}
                        className="doc-iframe doc-text"
                    />
                );
            default:
                return (
                    <div className="doc-unsupported">
                        <p>Document type not supported for inline viewing.</p>
                        <a href={path} download className="doc-download-link">
                            Download {doc.name}
                        </a>
                    </div>
                );
        }
    };

    return(
        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode} />
            <BackButton />
            
            <div className="documents-page dark-theme">
                {/* Page Header */}
                {/* <div className="documents-header">
                    <h1 className="documents-title">
                        <span className="title-icon" role="img" aria-label="documents">📚</span>
                        Document Library
                    </h1>
                    <p className="documents-subtitle">
                        Access manuals, handbooks, and operational documents
                    </p>
                </div> */}

                {/* Main Content Area */}
                <div className="documents-container">
                    {/* Navigation Sidebar */}
                    <aside className="documents-nav" role="navigation" aria-label="Document Navigation">
                        <h2 className="nav-title">Available Documents</h2>
                        <nav className="nav-list">
                            {documents.map((doc) => (
                                <button
                                    key={doc.id}
                                    className={`nav-item ${selectedDoc.id === doc.id ? 'active' : ''}`}
                                    onClick={() => setSelectedDoc(doc)}
                                    aria-label={`View ${doc.name}`}
                                    aria-current={selectedDoc.id === doc.id ? 'page' : undefined}
                                >
                                    <span className="nav-item-icon" role="img" aria-hidden="true">
                                        {doc.icon}
                                    </span>
                                    <div className="nav-item-content">
                                        <span className="nav-item-name">{doc.name}</span>
                                        <span className="nav-item-desc">{doc.description}</span>
                                    </div>
                                </button>
                            ))}
                        </nav>
                    </aside>

                    {/* Document Viewer */}
                    <main className="document-viewer" role="main">


                        {/* Document Content */}
                        <div className="viewer-content">
                            {renderDocument(selectedDoc)}
                        </div>
                    </main>
                </div>

                {/* Image Modal */}
                {isModalOpen && selectedDoc.type === 'image' && (
                    <div
                        className="image-modal-overlay"
                        onClick={() => setIsModalOpen(false)}
                        role="dialog"
                        aria-modal="true"
                        aria-label="Full size image viewer"
                    >
                        <div className="image-modal-content">
                            <button
                                className="modal-close-btn"
                                onClick={() => setIsModalOpen(false)}
                                aria-label="Close modal"
                            >
                                ✕
                            </button>
                            <img
                                src={getDocumentPath(selectedDoc.filename)}
                                alt={selectedDoc.name}
                                className="modal-image"
                                onClick={(e) => e.stopPropagation()}
                            />
                            <div className="modal-caption">
                                <span className="modal-caption-icon" role="img" aria-hidden="true">
                                    {selectedDoc.icon}
                                </span>
                                <span className="modal-caption-text">{selectedDoc.name}</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}

export default DocumentsPage;
